module.exports = __webpack_public_path__ + "img/packages/top_row_laptop.78993f.png";